import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "babel-polyfill";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import "./assets/css/reset.scss";
import api from "./api/apiList"; // axios封装
import "./assets/iconfont/iconfont.css"; // iconfont
import * as custom from "./assets/js/filters";
import clipboard from 'clipboard';
import htmlToPdf from '@/assets/js/htmlToPdf'
Vue.use(htmlToPdf)

//注册到vue原型上
Vue.prototype.clipboard = clipboard;

Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key]);
});

Vue.prototype.$api = api
Vue.use(ElementUI);
Vue.use(MintUI)
// Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {

  },
}).$mount("#app");